import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule, UrlModule } from '@spartacus/core';
import {
  GlobalMessageComponentModule,
  MediaModule,
  OutletRefModule,
  PageComponentModule,
  PageLayoutModule,
  PageSlotModule,
} from '@spartacus/storefront';

import { KnBrOutletComponent } from './kn-br-outlet.component';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';
import { ContextModalComponent } from './context-change-modal/context-change-modal.component';

@NgModule({
    imports: [
        CommonModule,
        OutletRefModule,
        PageComponentModule,
        PageLayoutModule,
        PageSlotModule,
        RouterModule,
        UrlModule,
        NgbModule,
        GlobalMessageComponentModule,
        I18nModule,
        KnBrCustomPipesModule,
        MediaModule,
        KnBrOutletComponent, ContextModalComponent
    ],
    exports: [KnBrOutletComponent],
})
export class KnBrOutletModule {}
